import { z } from 'zod';
import { CaregiverApplicationReadinessMissingItemSchema, CaregiverStatusSchema, } from './application.schema.js';
/**
 * Phase 5g (change-list 1.1) — the ONBOARDING stage: contract acceptance +
 * onboarding-readiness. Banking / SIN / HST live in `tax-info.schema.ts`
 * (their ACTIVE-only guard is relaxed to ONBOARDING|ACTIVE in 5g-c).
 */
/** POST /me/caregiver/contract request — the caregiver accepts the version
 *  they were shown (Q5=A click-through). The backend rejects a stale version
 *  so a cached page can't accept superseded terms. */
export const CaregiverContractAcceptRequestSchema = z.object({
    version: z.string().min(1).max(50),
});
/** POST /me/caregiver/contract response. `activated` is true when this
 *  acceptance was the last onboarding gate item and flipped the caregiver
 *  to ACTIVE. */
export const CaregiverContractAcceptResponseSchema = z.object({
    accepted: z.literal(true),
    version: z.string(),
    acceptedAt: z.string().datetime(),
    activated: z.boolean(),
});
/** GET /me/caregiver/contract response — current version + this caregiver's
 *  acceptance state, so the portal can render "accept" vs "accepted". */
export const CaregiverContractStateResponseSchema = z.object({
    currentVersion: z.string(),
    accepted: z.boolean(),
    acceptedVersion: z.string().nullable(),
    acceptedAt: z.string().datetime().nullable(),
});
/** GET /me/caregiver/onboarding-readiness response — the ONBOARDING → ACTIVE
 *  gate, mirroring application-readiness. `missing` reuses the shared
 *  missing-item shape (with the ONBOARDING category for banking/SIN/contract
 *  legs). `complete` true means the auto-flip has fired (status is ACTIVE). */
export const CaregiverOnboardingReadinessResponseSchema = z.object({
    status: CaregiverStatusSchema,
    complete: z.boolean(),
    missing: z.array(CaregiverApplicationReadinessMissingItemSchema),
    contractVersion: z.string(),
    contractAccepted: z.boolean(),
    // Banking lifecycle for the onboarding tab's banking step. The `missing` list
    // only distinguishes verified-vs-not (banking:unverified), which reads as
    // "Submit your banking" even after submission. These let the tab show the true
    // state: not-submitted vs submitted-awaiting-verification vs rejected.
    bankingSubmitted: z.boolean(),
    bankingRejected: z.boolean(),
    bankingRejectionReason: z.string().nullable(),
});
//# sourceMappingURL=onboarding.schema.js.map